import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  align-items: center;
`;

const appearFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Content = styled.div`
  animation: ${appearFromBottom} 1s;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: 700px;

  h2 {
    margin-bottom: 24px;
  }
`;

export const FormArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  animation: ${appearFromBottom} 1s;

  width: 45vw;
  margin-top: 140px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  background: #17171e;
  border-radius: 10px;
  padding: 32px 0;

  form {
    width: 370px;

    h2 {
      font-size: 32px;
      color: #7086f5;
      padding-bottom: 48px;
    }

    input {
      width: 280px;
    }
  }
`;

export const AddAccountForm = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 24px;

  div {
    flex: 1;
    margin-right: 16px;
  }

  button {
    width: 150px;
    margin: 0;
  }
`;

export const AccountList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AccountItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 10px;
  background: #3e3b47;
  margin-bottom: 10px;

  & > div {
    display: flex;
    align-items: center;
    flex: 1;
  }

  strong {
    width: 150px;
    margin-right: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input[type='range'] {
    flex: 1;
    margin: 0 16px;
    -webkit-appearance: none;
    appearance: none;
    height: 8px;
    background: #5636d3;
    border-radius: 5px;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 20px;
      height: 20px;
      background: #ff9000;
      border-radius: 50%;
      cursor: pointer;
    }

    &::-moz-range-thumb {
      width: 20px;
      height: 20px;
      background: #ff9000;
      border-radius: 50%;
      cursor: pointer;
    }
  }

  span {
    width: 60px;
    text-align: right;
    font-weight: bold;
  }

  .amount {
    width: 120px;
    margin-left: 16px;
    text-align: right;
    font-weight: bold;
    color: #4caf50;
  }

  button {
    background: transparent;
    border: 0;
    color: #c53030;
    margin-left: 16px;
    transition: color 0.2s;

    &:hover {
      color: ${shade(0.2, '#c53030')};
    }
  }
`;

export const NoAccounts = styled.div`
  text-align: center;
  margin-top: 40px;
  font-size: 18px;
  color: #666360;
`;

export const SubmitButtonContainer = styled.div`
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
`;
